import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const usePostTagsQuery = createQueryHook(MembershipsCreatorApiClient.getPostTags, {
  queryKey: ['postTags'],
  select: (data) => {
    return {
      tags: data.tags.slice().reverse(),
      pagination: data.pagination,
    }
  },
})
